import { render, staticRenderFns } from "./CredenciamentoExecucaoFornecedorVazio.vue?vue&type=template&id=0971c076&scoped=true"
import script from "./CredenciamentoExecucaoFornecedorVazio.vue?vue&type=script&lang=js"
export * from "./CredenciamentoExecucaoFornecedorVazio.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoExecucaoFornecedorVazio.vue?vue&type=style&index=0&id=0971c076&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971c076",
  null
  
)

export default component.exports